module.exports = "<div class=\"row copy-row\">\n    <div class=\"col-md-8 col-md-push-2 header\" *ngIf=\"item.title\" #header >\n        <h2>{{item.title}}</h2>\n    </div>\n    <div class=\"col-md-8 col-md-push-2 copy\">        \n        <copy [item]=\"item\" [pre]=\"pre\"></copy>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/copy-row/copy-row.template.html
// module id = 744
// module chunks = 2